// css =>
import "../../BaseStructure.css";
import Styled from "./portfolio.module.css";

// componenets =>
import Menu from "../../components/menu/menu.comp";
import SpinnerBar from "../../components/spinner-bar/spinner.comp";
import ContentBox from "../../components/content-box/content-box.comp";
import StoryViewer from "../../components/story-viewer/story-viewer.comp";
import CategoryFilterMenu from "../../components/category-filter-menu/category-filter-menu.comp";
import PortfolioServiceBox from "../../components/portfolio-services-box/portfolio-services-box.comp";
import CategoryFilterSubMenu from "../../components/category-filter-sub-menu/category-filter-sub-menu.comp";

// icons =>
import LocationIcon from "../../assets/icons/location-icon.png";

import Videos from "../../assets/icons/videos-icon.png";
import Pictures from "../../assets/icons/pictures-icon.png";

// pictures =>
import Pic1 from "../../assets/pictures/portfilo-pic1.webp";

import Pic3 from "../../assets/pictures/pic_3.jpg";
import Pic5 from "../../assets/pictures/pic-5.jpg";
import Pic10 from "../../assets/pictures/pic-10.jpg";

import one from "../../assets/pictures/portfolio_service/one.jpg";
import two from "../../assets/pictures/portfolio_service/two.jpg";
import three from "../../assets/pictures/portfolio_service/three.jpg";
import four from "../../assets/pictures/portfolio_service/four.jpg";
import five from "../../assets/pictures/portfolio_service/five.jpg";
import six from "../../assets/pictures/portfolio_service/six.jpg";

// react =>
import { useEffect, useState, useRef } from "react";

// services =>
import { getPortfolioList, getCategoryList, getPortfolioStoryList, getPortfolioImageList, getPortfolioVideoList } from "./portfolio-service";

// language =>
import { getTranslation } from '../../i18n/get-translation';
import { useLanguage } from '../../context/language-context';
import { getTranslatedField } from '../../utils/get-translated-field';

// context =>
import { useTheme } from '../../context/theme-context';

function Portfolio () {
    const filterSubMenuRef = useRef(null);

    const { language } = useLanguage();
    const t = (key) => getTranslation(language, key);

    const [open, setOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(1);

    const [alreadyIndex, setAlreadyIndex] = useState(0);
    const [isLoadingContent, setIsLoadingContent] = useState(false);

    const [categoryUrl, setCategoryUrl] = useState("");
    const [categoryList, setCategoryList] = useState([]);

    const [portfolioList, setPortfolioList] = useState([]);
    const [portfolioStoryList, setPortfolioStoryList] = useState([]);
    const [portfolioVideoList, setPortfolioVideoList] = useState([]);
    const [portfolioImageList, setPortfolioImageList] = useState([]);

    const [isFilteringSubMenuOpen, setIsFilteringSubMenuOpen] = useState(false);
    
    const pictures = portfolioImageList.map(item => item.image) || [];
    const videos = portfolioVideoList.map(item => item.video_file) || [];

    const { theme } = useTheme();

    useEffect(() => {
        const handleClickOutside = (event) => {

            if (
                isFilteringSubMenuOpen &&
                filterSubMenuRef.current &&
                !filterSubMenuRef.current.contains(event.target)
            ) {
                setIsFilteringSubMenuOpen(false);
            }

        };

        document.addEventListener("pointerdown", handleClickOutside);

        return () => {
            document.removeEventListener("pointerdown", handleClickOutside);
        };
    }, [isFilteringSubMenuOpen]);

    useEffect(() => {
        document.title = "برگ سبز | نمایش نمونه کار ها";

        const fetchPortfolio = async () => {
            const [portfolio, categorys] = await Promise.all([
                getPortfolioList(categoryUrl),
                getCategoryList(),
            ])

            setPortfolioList(portfolio);
            setCategoryList(categorys);
        }

        fetchPortfolio();
    }, [categoryUrl]);

    useEffect(() => {
        const id = portfolioList[alreadyIndex]?.id;
        if (!id) return;

        const fetchContent = async () => {
            setIsLoadingContent(true);

            const [stories, images, videos] = await Promise.all([
                getPortfolioStoryList(id),
                getPortfolioImageList(id),
                getPortfolioVideoList(id),
            ]);

            setPortfolioStoryList(stories);
            setPortfolioImageList(images);
            setPortfolioVideoList(videos);

            setIsLoadingContent(false);
        };

        fetchContent();
    }, [alreadyIndex, portfolioList]);

    const handleOpenFilteringSubMenu = () => {
        if (isFilteringSubMenuOpen) {
            setIsFilteringSubMenuOpen(false);
        } else {
            setIsFilteringSubMenuOpen(true);
        }
    }

    const handleCategoryFilterChange = (categoryId) => {
        setAlreadyIndex(0)
        setCategoryUrl(categoryId);
        setIsFilteringSubMenuOpen(false);
    }

    return (
        <>
            <div>
                {
                    open && (
                        <StoryViewer
                            stories={portfolioStoryList.map(story => ({
                                id: story.id,
                                type: story.story_type,
                                url: story.file,
                                // caption: story.caption,
                                caption: getTranslatedField(story, 'caption', language),
                                username: 'Barg sabz',
                                duration: story.duration || 5000,
                                avatarUrl: story.thumbnail,
                            }))}
                            initialIndex={ currentIndex }
                            onClose={() => setOpen(false)}
                        />
                    )
                }
            </div>

            <header>
                <Menu />

                <div ref={ filterSubMenuRef }>
                    <CategoryFilterMenu
                        mainTitle={ t('filterAndCategoryMenuOption1_2') }
                        subMenuTitle={ t('filterAndCategoryMenuOption3_2') }
                        numberOfItems={`${ portfolioList.length } ${ t('filterAndCategoryMenuOption1_2') }`}
                        onClick={ handleOpenFilteringSubMenu }
                    />
                    <CategoryFilterSubMenu
                        categorys={ categoryList }
                        isOpen={ isFilteringSubMenuOpen }
                        handleCategoryFilterChange={ handleCategoryFilterChange }
                        cloesWithBackdrop={() => {
                            setIsFilteringSubMenuOpen(false);
                        }}
                    />
                </div>
            </header>

            <main>
                <div className={`row ${ Styled.project_info_header_box } `}>
                    <div
                        className={`col-12 ${ Styled.project_info_box } `}
                        style={{
                            backgroundColor: theme === "day" ? "#C9CCC2" : ""
                        }}>
                        <div className="row">
                            <div
                                className={`col-2 ${ Styled.right_slider_button_box } `}
                                style={{
                                    borderColor: theme === "day" ? "#474D3D" : ""
                                }}
                                onClick={() => {
                                    if (alreadyIndex < portfolioList.length - 1) {
                                        setAlreadyIndex(alreadyIndex + 1);
                                    } else {
                                        setAlreadyIndex(0);
                                    }
                                }}>
                                <div
                                    style={{
                                        backgroundColor: theme === "day" ? "#474D3D" : ""
                                    }}></div>
                            </div>
                            <div className={`col-6 ${ Styled.project_info_body_box } `}>
                                <p
                                    style={{
                                        color: theme === "day" ? "#000000" : ""
                                    }}
                                >{ getTranslatedField(portfolioList[alreadyIndex]?.category, 'name', language) }</p>
                            </div>
                            <div
                                className={`col-2 ${ Styled.left_slider_button_box } `}
                                style={{
                                    borderColor: theme === "day" ? "#474D3D" : ""
                                }}
                                onClick={() => {
                                    if (alreadyIndex >= 1) {
                                        setAlreadyIndex(alreadyIndex - 1);
                                    } else {
                                        setAlreadyIndex(portfolioList.length - 1);
                                    }
                               }}>
                                <div
                                    style={{
                                        backgroundColor: theme === "day" ? "#474D3D" : ""
                                    }}
                                ></div>
                            </div>
                        </div>
                    </div>

                    <div
                        className={`row ${ Styled.product_info_header_background } `}
                        style={{
                            border: theme === "day" ? "2px solid #474D3D" : ""
                        }}>
                        <div className={`col-3 ${ Styled.Project_Text_Info_Frame } `}>
                            <p
                                style={{
                                    color: theme === "day" ? "#000000" : ""
                                }}>
                                { alreadyIndex + 1 }/{ portfolioList?.length }
                            </p>
                        </div>
                        <div className={`col-6 ${ Styled.Project_Text_Info_Frame } `}>
                            <p
                                style={{
                                    color: theme === "day" ? "#000000" : "",
                                    fontSize: '14px',
                                    marginTop: '22px'
                                }}>
                                { getTranslatedField(portfolioList[alreadyIndex], 'title', language) }
                            </p>
                        </div>
                        <div className={`col-3 ${ Styled.Project_Text_Info_Frame } `}>
                            <p
                                style={{
                                    color: theme === "day" ? "#000000" : ""
                                }}>
                                { getTranslatedField(portfolioList[alreadyIndex], 'location', language) }
                            </p>
                        </div>

                        <div
                            className={`col-6 ${ Styled.Project_Text_Info_Frame_Desktop } `}
                            style={{
                                float: language === "en" ? "left" : "right",
                            }}>
                            <div
                                className="col-12"
                                style={{
                                    textAlign: language === "en" ? "left" : "right",
                                    marginRight: language === "en" ? "0" : "",
                                    marginLeft: language === "en" ? "31px" : ""
                                }}>
                                <h1
                                    style={{
                                        color: theme === "day" ? "#000000" : "",
                                        marginLeft: language === "en" ? "31px" : "",
                                        marginRight: language === "fa" ? "10px" : ""
                                    }}>
                                    { getTranslatedField(portfolioList[alreadyIndex], 'title', language) }
                                </h1>
                            </div>
                            <div
                                className="col-12"
                                style={{
                                    textAlign: language === "en" ? "left" : "right",
                                    marginRight: language === "en" ? "0" : ""
                                }}>
                                <img
                                    alt="مکان"
                                    src={ LocationIcon }
                                    style={{
                                        marginRight: language === "fa" ? '4px' : "",
                                    }}
                                />
                                <span
                                    style={{
                                        color: theme === "day" ? "#000000" : ""
                                    }}>
                                    { getTranslatedField(portfolioList[alreadyIndex], 'location', language) }
                                </span>
                            </div>
                        </div>

                        <div className={`col-12 ${ Styled.product_info_right_body } `}>
                            {
                                portfolioStoryList && portfolioStoryList.length > 0 ? (
                                    portfolioStoryList.map((item, index) => {
                                        return <PortfolioServiceBox
                                                key={ item.id }
                                                servicePicture={ item.thumbnail }
                                                serviceName={ getTranslatedField(item, 'title', language) }
                                                onClick={() => {
                                                    setCurrentIndex(index);
                                                    setOpen(true);
                                                }}
                                            />
                                    })
                                ) : null
                            }
                        </div>

                        {/* <div className={`col-12 ${ Styled.product_info_left_body } `}>
                            <p
                                style={{
                                    color: theme === "day" ? "#000000" : ""
                                }}>{ getTranslatedField(portfolioList[alreadyIndex], 'title', language) }</p>

                            <div className={ Styled.location_box }>
                                <img src={ LocationIcon } alt="" />
                                <span
                                    style={{
                                        color: theme === "day" ? "#000000" : "",
                                    }}
                                >{ getTranslatedField(portfolioList[alreadyIndex], 'location', language) }</span>
                            </div>
                        </div> */}
                    </div>

                    <div className={`col-12 ${ Styled.project_banner_box } `}>
                        <img src={ portfolioList[alreadyIndex]?.banner_thumbnail } alt="" loading="lazy" />
                    </div>
                </div>

                <div className={`row ${ Styled.portfolio_content_box } `}>
                    <div className={`col-12 ${ Styled.project_banner_desktop_box } `}>
                        <div><img src={ portfolioList[alreadyIndex]?.banner_thumbnail } alt="" loading="lazy" /></div>
                    </div>

                    {
                        isLoadingContent ? (
                            <div className={`col-5 ${ Styled.spinner_bar_box } `}>
                                <SpinnerBar />
                            </div>
                        ) : (
                            <div className={`col-12 ${ Styled.portfolio_content_show } `}>
                                <ContentBox contentBoxIcon={ Videos } numberOfContentText={`${ videos.length } ${ t('contentType1') }`} contents={ videos } contentType="video" />
                                <ContentBox contentBoxIcon={ Pictures } numberOfContentText={`${ pictures.length } ${ t('contentType2') }`} contents={ pictures } contentType="image" />
                            </div>
                        )
                    }
                </div>
            </main>

            <footer>
                <div className={`row ${ Styled.portfolio_service_box } `}>
                    {
                        portfolioStoryList && portfolioStoryList.length > 0 ? (
                            portfolioStoryList.map((item, index) => {
                                return <PortfolioServiceBox
                                    key={ item.id }
                                    servicePicture={ item.thumbnail }
                                    serviceName={ getTranslatedField(item, 'title', language) }
                                    onClick={() => {
                                        setCurrentIndex(index);
                                        setOpen(true);
                                    }}
                                />
                            })
                        ) : null
                    }
                </div>
            </footer>
        </>
    );
}

export default Portfolio;
